import appApi from '../../../../../../api/app-api';
import { ProgramYearsDistribution } from '../../../../../../api/types/programs/program.type';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const getProgramDetailsForImportOperation = async (
  branchId: number,
  programId: number,
): Promise<ProgramYearsDistribution | null> => {
  try {
    const res = await appApi.getProgramDetails(branchId, programId);

    if (res.data.ok) {
      return res.data.body;
    }

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return null;
    }

    toast.error('טעינת פרטי תוכנית נכשלה, נסה שוב');
    return null;
  } catch (e) {
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    return null;
  }
};
